// TODO: use react-query/tRPC/make this a hook

// NOTE: bloodKits.js file with all the fetches made to TWD-HEALTH backend related to blood kits
const bloodKitsEndpoint = '/api/health/api/bloodKits'

// NOTE: Get a paginated page of non-archived blood kits for a specific user
const getKits = async (userId: string, token: string, page: string, limit: string) => {
	// NOTE: throw error if any of the fields needed for the fetch are not provided
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')
	if (!page) throw new Error('No page provided')
	if (!limit) throw new Error('No limit provided')

	const query = new URLSearchParams({ page, limit })

	return await fetch(`${bloodKitsEndpoint}/${userId}?${query.toString()}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

// NOTE: Get the latest processed investigation
const getLatest = async (userId: string, token: string) => {
	// NOTE: throw error if any of the fields needed for the fetch are not provided
	if (!userId) throw new Error('No user ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${bloodKitsEndpoint}/latest/${userId}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

// NOTE: Register a new investigation
const registerKit = async (data: FormData, token: string) => {
	// NOTE: throw error if any of the fields needed for the fetch are not provided
	if (!data) throw new Error('No blood kit data provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${bloodKitsEndpoint}/`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`
		},
		body: data
	})
}

// NOTE: Update the details of an investigation
const updateDetails = async (kitId: string, data: FormData, token: string) => {
	// NOTE: throw error if any of the fields needed for the fetch are not provided
	if (!kitId) throw new Error('No blood kit ID provided')
	if (!data) throw new Error('No blood kit data provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${bloodKitsEndpoint}/details/${kitId}`, {
		method: 'PATCH',
		headers: {
			Authorization: `Bearer ${token}`
		},
		body: data
	})
}

// NOTE: Mark an investigation as viewed after the user watches the video
const watchedVideo = async (kitId: string, token: string) => {
	// NOTE: throw error if any of the fields needed for the fetch are not provided
	if (!kitId) throw new Error('No blood kit ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${bloodKitsEndpoint}/watched/${kitId}`, {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

// NOTE: "Delete" an investigation by setting its archived flag to true
const archiveKit = async (kitId: string, token: string) => {
	// NOTE: throw error if any of the fields needed for the fetch are not provided
	if (!kitId) throw new Error('No blood kit ID provided')
	if (!token) throw new Error('No token provided')

	return await fetch(`${bloodKitsEndpoint}/${kitId}`, {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	})
}

export {
	getKits,
	registerKit,
	updateDetails,
	watchedVideo,
	archiveKit,
	getLatest
}
